<div class="lista-vertical">

  @for (campo of campos; track campo; let i = $index) {
    <div class="linha-item">
      <div class="linha-item-corpo">
        <p-floatLabel variant="on" class="campo-nome">
          <input pInputText [id]="'campoNome' + i" [(ngModel)]="campo.nome" />
          <label [for]="'campoNome' + i">Nome do campo</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="campo-valor-padrao">
          <textarea pTextarea [id]="'campoValorPadrao' + i" rows="1" [(ngModel)]="campo.valorPadrao"></textarea>
          <label [for]="'campoValorPadrao' + i">Valor padrão</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="campo-tag">
          <input pInputText [id]="'campoTag' + i" [(ngModel)]="campo.tagHtmlPdf" spellcheck="false" />
          <label [for]="'campoTag' + i">Tag no template</label>
        </p-floatLabel>
      </div>
      <div class="linha-item-acoes">
        <button mat-icon-button matTooltip="Remover" (click)="remover(campo)">
          <i class="pi pi-trash"></i>
        </button>
      </div>
    </div>
  }

  <button mat-stroked-button class="btn-adicionar" (click)="adicionar()">
    <i class="pi pi-plus"></i> Adicionar campo
  </button>

</div>
